import axios from "axios";
import { getApiKeyFromSessionStorage } from "@/utils/sessionStorage";

const http = axios.create({
  baseURL: process.env.VUE_APP_BACKEND,
  headers: {
    "Content-Type": "application/json",
  },
});

http.interceptors.request.use(
  (config) => {
    const apiKey = getApiKeyFromSessionStorage();
    config.headers["x-api-key"] = apiKey;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (process.env.NODE_ENV === "development") {
      return Promise.reject(error);
    }
    if (error.response && error.response.status === 401) {
      window.location = "/unauthorized";
    } else {
      window.location = "/error";
    }
    return Promise.resolve(error);
  }
);

export default http;
